import { AdminDrive } from '@/components/admin/AdminDrive';
import { BRAND_STARTER_FOLDERS } from '@/features/admin/model';

export function BrandKitPage() {
  return (
    <AdminDrive
      library="brand"
      title="Brand kit"
      starterFolders={BRAND_STARTER_FOLDERS}
      emptyTitle="No brand files yet"
    />
  );
}
